<div class="not-fount">
  <img src="assets/images/errors/404.png" alt="">
  <div class="not-fount__title">{{'sorryPageNotFound' | translate}}</div>
  <div class="not-fount-block">
    <div class="not-fount__text">{{'youCanGoToThe'| translate}}</div>
    <a href="/" class="not-fount__text-blue">{{'mainPageOfThe' | translate}}</a>
    <div class="not-fount__text">{{'site' | translate}}</div>
  </div>
</div>
